import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
    rdt: (...args: any[]) => void;
  }
}

const CONSENT_KEY = 'cookie-consent';

export const CookieConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      // No choice made yet - show banner, tracking works by default (opt-out model)
      setShowBanner(true);
    } else if (consent === 'declined') {
      // User previously declined - re-apply denied consent
      updateConsent(false);
    }
    // If accepted, do nothing - tracking already works by default
  }, []);

  const updateConsent = (granted: boolean) => {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        'ad_storage': granted ? 'granted' : 'denied',
        'ad_user_data': granted ? 'granted' : 'denied',
        'ad_personalization': granted ? 'granted' : 'denied',
        'analytics_storage': granted ? 'granted' : 'denied',
        'personalization_storage': granted ? 'granted' : 'denied',
      });
    }
  };

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    updateConsent(true);
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    updateConsent(false);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-4 md:right-auto md:max-w-sm z-50 bg-background border border-border rounded-lg shadow-lg p-4 animate-in slide-in-from-bottom-4 duration-300">
      <p className="text-sm text-foreground mb-3">
        We use cookies to improve your experience and analyze site usage.
      </p>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={handleDecline}
          className="flex-1"
        >
          Decline
        </Button>
        <Button
          size="sm"
          onClick={handleAccept}
          className="flex-1"
        >
          Accept
        </Button>
      </div>
    </div>
  );
};
